const navbar = {
  packages: "Packages",
  hotelPackages: "Hotel Packages",
  experiences: "Experiences",
  close: "Close",
  hotDeals: "Hot Deals",
  dashboard: "Dashboard",
  pricing: "Pricing",
};

export default navbar;
